import log from 'loglevel';
const loggingLevels = ['info', 'error', 'silent'] as const;

export type LoggingLevel = (typeof loggingLevels)[number];

export const isLoggingLevel = (string: string): string is LoggingLevel =>
  loggingLevels.includes(string as LoggingLevel);

export interface LoggingService {
  setLevel: (level: LoggingLevel) => void;
  log: (...msg: Array<any>) => void;
  error: (...msg: Array<any>) => void;
}

export class LogLevelLoggingService implements LoggingService {
  constructor(level: LoggingLevel = 'info') {
    log.setLevel(level);
  }

  setLevel(level: LoggingLevel) {
    return log.setLevel(level);
  }

  log(...msg: Array<any>) {
    return log.info(...msg);
  }

  error(...msg: Array<any>) {
    return log.error(...msg);
  }
}

export const loggingServiceFactory = ({
  setLevel = () => {},
  log = () => {},
  error = () => {},
}: Partial<LoggingService> = {}): LoggingService => ({
  setLevel,
  log,
  error,
});
